module.exports = __webpack_public_path__ + "img/line.414687b5.png";